import { Stack } from "@mantine/core"

import { AGECResponses } from "@tfg/types/endpoints/agec"
import { ecoscoreAlignCSSVariable } from "@tfg/types/schemas/communication-studio/cssVariables"

import { DesignStudioParametersToolkit } from "../utils/designStudioParametersToolkit"

import { EcoScoreSVG } from "./EcoLabel/EcoScoreSVG"

type EcoScoreProps = {
  agecData: AGECResponses.GenericAgecData
  ecoScoreDataSource: string | null
}

export const DEFAULT_ECOSCORE_SOURCE = "ecobalyse"

export const EcoScore = ({
  agecData,
  ecoScoreDataSource = DEFAULT_ECOSCORE_SOURCE,
}: EcoScoreProps) => {
  if (!agecData.ecoScoreData) {
    return null
  }
  const ecoScoreData =
    agecData.ecoScoreData.sources[
      ecoScoreDataSource ?? DEFAULT_ECOSCORE_SOURCE
    ] ?? null
  if (!ecoScoreData) {
    return null
  }
  const { ecoScoreCost, ecoScoreCostPer100g } = ecoScoreData
  return (
    <Stack
      align={DesignStudioParametersToolkit.getCssVariableLiteralName(
        ecoscoreAlignCSSVariable
      )}
      justify="center"
      w="100%"
    >
      <EcoScoreSVG cost={ecoScoreCost} costPer100g={ecoScoreCostPer100g} />
    </Stack>
  )
}
